export default __webpack_public_path__ + "static/media/css3.aa088dc1.png";